'use client';
import { Card } from '@ahafood/ui/components/card';
import { useMemo } from 'react';
import TrendingHeader from '../session/trending-header';
import TrendingItemList from '../session/trending-item-list';
import AmoriSidebar from '@/app/[locale]/amori/amori-sidebar';
import { useIsMobile } from '@/lib/is-mobile';
import { useAiFoodOrderStore } from '@/store';

export default function TrendingPageContent() {
  const isMobile = useIsMobile();
  const address = useAiFoodOrderStore.use.address();
  const lat = useMemo(() => address?.lat, [address]);
  const lng = useMemo(() => address?.lng, [address]);

  // Mobile layout
  if (isMobile) {
    return (
      <div className="min-h-screen bg-gradient-to-b from-[#FFF7F2] via-white to-[#EAECEF]">
        <TrendingHeader />
        <div className="bg-white h-[170px] w-full"></div>
        <div className="px-0 mt-6">
          <TrendingItemList lat={lat ?? 0} lng={lng ?? 0} />
        </div>
      </div>
    );
  }

  // Desktop layout
  return (
    <div className="min-h-screen bg-white">
      {/* Compact Header - Desktop */}
      <div className="border-b border-neutral-10 bg-white sticky top-0 z-40">
        <div className="max-w-screen-2xl mx-auto px-12 py-4">
          <div className="flex items-center gap-4">
            <h1 className="text-2xl font-bold text-primary-50">Xu hướng</h1>
            <p className="text-sm text-neutral-60">
              Top món ngon đang được yêu thích
            </p>
          </div>
        </div>
      </div>

      {/* 2-Column Content */}
      <div className="max-w-screen-2xl mx-auto px-12 py-8">
        <div className="grid grid-cols-[1fr_380px] xl:grid-cols-[1fr_420px] gap-8">
          {/* Main Content - Left */}
          <main className="min-w-0">
            <TrendingItemList lat={lat ?? 0} lng={lng ?? 0} />
          </main>

          {/* Sidebar - Right */}
          <aside className="sticky top-24 h-[calc(100vh-120px)] space-y-6">
            {/* Amori Chat */}
            <AmoriSidebar defaultCollapsed={false} />

            {/* Quick Info */}
            <Card className="p-6 bg-gradient-to-br from-[#FFF7F2] to-white border border-neutral-10">
              <h3 className="font-bold text-neutral-90 mb-4 flex items-center gap-2">
                <span className="text-2xl">⭐</span>
                Món ăn xu hướng
              </h3>
              <div className="space-y-3 text-sm text-neutral-70">
                <p>Khám phá các món ăn đang hot nhất khu vực của bạn</p>
                <p>Được nhiều người yêu thích và đánh giá cao</p>
              </div>
            </Card>
          </aside>
        </div>
      </div>
    </div>
  );
}
